import { LandingTranslate } from './landingTranslate.model';

const landingTranslatePTBR: LandingTranslate = {
  nav: {
    features: 'Funcionalidades',
    how: 'Como funciona',
    pricing: 'Preço',
    faq: 'FAQ',
    login: 'Entrar',
    signup: 'Começar grátis',
    goToApp: 'Ir para o app',
    menu: 'Menu',
    closeMenu: 'Fechar menu',
    language: 'Idioma',
    theme: 'Tema',
  },
  hero: {
    badge: 'Beta aberto · grátis para os 100 primeiros estúdios',
    headline: 'Pare de perder cliente no WhatsApp.',
    sub: 'O CRM feito só pra fotografia. Do primeiro contato à entrega, tudo num lugar só — leads, eventos, contratos e pagamentos.',
    ctaPrimary: 'Começar grátis',
    ctaSecondary: 'Ver como funciona',
    b1: 'Sem cartão',
    b2: 'Setup em 2 minutos',
    b3: 'Seus dados são seus',
  },
  mockup: {
    address: 'app.clickersphere.com / eventos',
    colScheduled: 'Agendados',
    colEditing: 'Em edição',
    colDelivered: 'Entregue',
    weddingTitle: 'Casamento Marina & Pedro',
    weddingDate: '26 Abr · 16:00',
    newbornTitle: 'Newborn Beatriz',
    newbornDate: '27 Abr · 10:00',
    bookTitle: 'Book corp. Rafael',
    bookDate: '29 Abr · 09:00',
    portraitTitle: 'Ensaio Carolina',
    portraitDetail: 'Ensaio confirmado · 14h',
    birthdayTitle: 'Aniversário 15 anos',
    birthdayDeadline: 'Prazo · 02 Mai',
    familyTitle: 'Família Souza',
    familyDetail: 'Contrato assinado',
    graduationTitle: 'Formatura Lucas',
    graduationDetail: 'Pago · R$ 2.800',
    leadTime: '09:41',
    leadStatus: 'Eventos',
    revenueLabel: '+R$ 4,8k',
    leadCount: '2 ativos',
    leadName: 'Marina Alves',
    leadSource: 'Novo lead · Instagram',
    phoneTitle: 'Eventos',
    phoneActive: '2 ativos',
    phoneRevenue: '+R$4,8k',
  },
  stats: {
    v1: '2 min',
    v2: '0',
    v3: '7 dias',
    v4: '100',
    s1: 'Pra começar do zero',
    s2: 'Planilhas necessárias',
    s3: 'Grátis pra testar',
    s4: 'Vagas no beta',
  },
  problem: {
    eyebrow: 'O PROBLEMA',
    title: 'Você é fotógrafo. Não administrador.',
    sub: 'Mas todo mês você gasta horas garimpando WhatsApp, planilhas e e-mails só pra lembrar quem é quem.',
    p1: { k: 'Hoje', v: '"Espera, o evento da Marina é 24 ou 26?"' },
    p2: { k: 'Hoje', v: '3 conversas no WhatsApp pra um único orçamento' },
    p3: { k: 'Hoje', v: 'Planilha do Excel + Google Calendar + caderninho' },
    p4: { k: 'Hoje', v: 'Lead some porque não respondeu em 2 dias' },
  },
  features: {
    eyebrow: 'FUNCIONALIDADES',
    title: 'Tudo o que um estúdio precisa. Nada que ele não precisa.',
    sub: 'Sem CRM genérico cheio de aba. Sem 4 ferramentas separadas. Só o essencial, polido até brilhar.',
    f1: {
      t: 'Pipeline de leads',
      d: 'Cadastra cliente em 4 campos. Marca como ativo, lê notas, vê histórico de eventos. Acabou.',
    },
    f2: {
      t: 'Quadro de eventos',
      d: 'Kanban arrastável. Crie suas próprias colunas: agendado, em edição, prova, entregue, pago — do seu jeito.',
    },
    f3: {
      t: 'Dashboard de início',
      d: 'Leads do mês, eventos da semana, próximos prazos. Você abre o app e sabe o dia em 3 segundos.',
    },
    f4: {
      t: 'Lembretes por email',
      d: 'Receba avisos de tarefas e parcelas a vencer direto no seu email. Nada passa batido.',
    },
    f5: {
      t: 'Multi-organização',
      d: 'Tem mais de um estúdio? Marca branca? Troca de tenant em 1 clique, dados isolados.',
    },
    f6: {
      t: 'Tema claro e escuro',
      d: 'Editando às 23h em sessão de fotos? O modo escuro nasceu pra isso.',
    },
  },
  how: {
    eyebrow: 'COMO FUNCIONA',
    title: 'Do "oi" no Direct ao "tá pago" — em 3 etapas.',
    s1: {
      label: 'Capte',
      t: 'Cadastre o lead',
      d: 'Nome, e-mail, Instagram, anotações. 30 segundos. Já fica salvo no histórico.',
    },
    s2: {
      label: 'Organize',
      t: 'Vire evento',
      d: 'Arraste do quadro: agendado → em edição → entregue. Status que você inventa.',
    },
    s3: {
      label: 'Entregue',
      t: 'Acompanhe no dashboard',
      d: 'Veja faturamento estimado, taxa de conversão e prazo de entrega — sem fórmula.',
    },
  },
  diff: {
    eyebrow: 'POR QUE NÃO UM CRM GENÉRICO?',
    title: 'Porque ensaio newborn não é venda B2B.',
    sub: 'Hubspot, Pipedrive e Notion fazem tudo. E é justamente esse o problema. O Clicker Sphere foi desenhado a partir do fluxo real de quem fotografa.',
    col1: ' ',
    col2: 'CRM genérico',
    col3: 'Clicker Sphere',
    r1: 'Vocabulário',
    r1a: 'Deal · Lead · Stage',
    r1b: 'Cliente · Evento · Entrega',
    r2: 'Configuração',
    r2a: 'Horas montando pipeline',
    r2b: '2 minutos, presets prontos',
    r3: 'Status',
    r3a: 'Fixos ou pago à parte',
    r3b: 'Você cria os que quiser',
    r4: 'Curva de aprendizado',
    r4a: 'Tutorial de 40 min',
    r4b: 'Abre e usa',
    r5: 'Foco',
    r5a: 'Vendas em geral',
    r5b: 'Fotografia, ponto.',
  },
  tst: {
    eyebrow: 'BETA',
    title: 'Primeiros estúdios do beta.',
    body: 'Seu estúdio pode estar aqui. Os primeiros 100 têm acesso grátis e canal direto com quem constrói o produto.',
    cta: 'Entrar no beta (grátis)',
  },
  pr: {
    eyebrow: 'PREÇO',
    title: 'Simples. Honesto. Cancela quando quiser.',
    sub: 'Durante o beta, tudo é grátis. Estes serão os preços no lançamento — quem entrar agora trava o valor pra sempre.',
    month: '/mês',
    popular: 'Mais popular',
    guarantee:
      '7 dias grátis nos planos pagos · sem cartão · cancela quando quiser',
    t1: {
      name: 'Solo',
      price: 'R$0',
      d: 'Pra sempre, durante o beta',
      f1: '1 organização',
      f2: 'Até 15 leads ativos',
      f3: 'Quadro de eventos ilimitado',
      f4: 'Dashboard básico',
      cta: 'Começar grátis',
    },
    t2: {
      name: 'Studio',
      price: 'R$ 29,90',
      d: 'Anual: R$ 299 (2 meses grátis)',
      f1: 'Tudo do Solo, ilimitado',
      f2: 'Status personalizados',
      f3: 'Dashboard completo + métricas',
      f4: 'Contratos em PDF com templates',
      f5: 'Suporte prioritário',
      cta: 'Entrar no beta (grátis)',
    },
    t3: {
      name: 'Coletivo',
      price: 'R$ 79,90',
      d: 'Anual: R$ 799 · equipes e marcas brancas',
      f1: 'Tudo do Studio',
      f2: 'Múltiplas organizações',
      f3: 'Permissões por papel',
      f4: 'Exportação de dados',
      f5: 'SLA de 24h',
      cta: 'Entrar no beta (grátis)',
    },
  },
  faq: {
    eyebrow: 'PERGUNTAS FREQUENTES',
    title: 'Tudo o que você quer saber antes de começar.',
    q1: 'O Clicker Sphere substitui meu WhatsApp?',
    a1: 'Não. WhatsApp continua sendo onde você conversa. O Clicker Sphere é onde a conversa vira lead, evento e entrega — para nada se perder.',
    q2: 'Posso criar meus próprios status de evento?',
    a2: 'Sim, nos planos pagos. Crie quantas colunas quiser, arraste pra reordenar, defina cor e ícone. Cada estúdio organiza do seu jeito.',
    q3: 'Meus dados são compartilhados com alguém?',
    a3: 'Nunca. Cada organização é isolada das demais. Você exporta tudo em CSV quando quiser (planos pagos) e cancela com 1 clique.',
    q4: 'Funciona no celular?',
    a4: 'Sim. Além do app web, temos app nativo pra iOS e Android — leve seus eventos no bolso, direto do celular.',
    q5: 'Já uso outro CRM. Dá pra migrar?',
    a5: 'Você exporta tudo em CSV quando quiser (planos pagos). Migrando de planilha, Hubspot ou Pipedrive? No plano Coletivo a gente faz a migração pra você.',
  },
  cta: {
    title: 'Menos planilha. Mais obturador.',
    sub: '2 minutos pra criar a conta. Zero compromisso. Cancela quando quiser.',
    primary: 'Começar agora',
    secondary: 'Voltar aos recursos',
  },
  ft: {
    about: 'CRM minimalista pra fotógrafos. Feito por quem cansou de planilha.',
    product: 'Produto',
    company: 'Empresa',
    legal: 'Legal',
    contact: 'Contato',
    terms: 'Termos',
    privacy: 'Privacidade',
    lgpd: 'LGPD',
    copy: '© 2026 Clicker Sphere. Todos os direitos reservados.',
    version: 'beta',
  },
};

export default landingTranslatePTBR;
